import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { AccountTitleAction, SubItemsSharedAction } from "../actions";
import * as accountTitleApi from "../api/accountTitle";
import * as subAccountTitleApi from "../api/subAccountTitle";
import { toastr } from "react-redux-toastr";
import { goBack } from "connected-react-router";
import { SetMessage } from "../assets/errorMessages";
import {
  defaultNormalizerWithSeparateMetaObj,
  fetchAllPages
} from "../assets/fetchAllPageTogether";

export function* watcherAccountTitle() {
  yield takeLatest(types.GET_ACCOUNT_TITLE_REQUEST, get);
  yield takeLatest(types.SHOW_ACCOUNT_TITLE_REQUEST, show);
  yield takeLatest(types.REMOVE_ACCOUNT_TITLE_REQUEST, remove);
  yield takeLatest(types.REMOVE_SUB_ACCOUNT_TITLE_REQUEST, removeSub);
  yield takeLatest(types.STORE_ACCOUNT_TITLE_REQUEST, store);
  yield takeLatest(types.STORE_SUB_ACCOUNT_TITLE_REQUEST, storeSub);
  yield takeLatest(
    types.GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_REQUEST,
    getTypesForDefaults
  );
  yield takeLatest(types.GET_DEFAULTS_ACCOUNT_TITLE_REQUEST, getDefaults);
  yield takeLatest(types.STORE_DEFAULT_ACCOUNT_TITLE_REQUEST, storeDefault);
  yield takeLatest(types.UPDATE_ACCOUNT_TITLE_REQUEST, update);
  yield takeLatest(types.UPDATE_SUB_ACCOUNT_TITLE_REQUEST, updateSub);
  yield takeLatest(types.IMPORT_FILE_ACCOUNT_TITLE_REQUEST, importFile);
}

function* get() {
  try {
    const response = yield fetchAllPages(
      getRequest,
      null,
      defaultNormalizerWithSeparateMetaObj,
      null,
      true
    );
    yield put(AccountTitleAction.getListSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(AccountTitleAction.getListFailure(message));
  }
}

function getRequest(pageNumber = null) {
  return accountTitleApi.getList(pageNumber);
}

function* show(action) {
  try {
    const response = yield call(showRequest, action.id);
    yield put(AccountTitleAction.showSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(AccountTitleAction.showFailure(message));
  }
}

function showRequest(id) {
  return accountTitleApi.show(id);
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id);
    yield put(AccountTitleAction.removeSuccess(action.id));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    if (action.goBack) {
      yield put(goBack());
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(AccountTitleAction.removeFailure());
  }
}

function removeRequest(id) {
  return accountTitleApi.remove(id);
}

function* store(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(storeRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    yield put(AccountTitleAction.storeSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(AccountTitleAction.storeFailure());
  }
}

function storeRequest(data) {
  return accountTitleApi.store(data);
}

function storeSubRequest(accountTitleId, data) {
  return subAccountTitleApi.store(accountTitleId, data);
}

function* storeSub(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(
      storeSubRequest,
      action.accountTitleId,
      action.data
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    yield put(AccountTitleAction.storeSubSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(AccountTitleAction.storeSubFailure());
  }
}

function* getTypesForDefaults() {
  try {
    const response = yield call(getTypesForDefaultsRequest);
    yield put(
      AccountTitleAction.getTypesForDefaultsSuccess(response.data.data)
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(AccountTitleAction.getTypesForDefaultsFailure(message));
  }
}

function getTypesForDefaultsRequest() {
  return accountTitleApi.getTypesForDefaultsList();
}

function* getDefaults(action) {
  try {
    const response = yield call(getDefaultsRequest, action.typeId);
    yield put(AccountTitleAction.getDefaultsSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(AccountTitleAction.getDefaultsFailure(message));
  }
}

function getDefaultsRequest(type) {
  return accountTitleApi.getDefaultsList(type);
}

function* storeDefault(action) {
  try {
    const response = yield call(storeDefaultRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(AccountTitleAction.storeDefaultSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(AccountTitleAction.storeDefaultFailure());
  }
}

function storeDefaultRequest(data) {
  return accountTitleApi.storeDefault(data);
}

function* update(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(updateRequest, action.id, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    yield put(AccountTitleAction.updateSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(AccountTitleAction.updateFailure());
  }
}

function updateRequest(id, data) {
  return accountTitleApi.update(id, data);
}

function* importFile(action) {
  try {
    const response = yield call(importFileRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(AccountTitleAction.importFileSuccess());
    yield put(goBack());
    yield put(AccountTitleAction.getList());
  } catch (error) {
    SetMessage(error, true);
    yield put(AccountTitleAction.importFileFailure());
  }
}

function importFileRequest(data) {
  return accountTitleApi.importFile(data);
}

function* updateSub(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(
      updateSubRequest,
      action.accountTitleId,
      action.id,
      action.data
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    yield put(AccountTitleAction.updateSubSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(AccountTitleAction.updateSubFailure());
  }
}

function updateSubRequest(accountTitleId, id, data) {
  return subAccountTitleApi.update(accountTitleId, id, data);
}

function* removeSub(action) {
  try {
    const response = yield call(
      removeSubRequest,
      action.accountTitleId,
      action.id
    );
    yield put(AccountTitleAction.removeSubSuccess(action));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(AccountTitleAction.removeSubFailure());
  }
}

function removeSubRequest(accountTitleId, id) {
  return subAccountTitleApi.remove(accountTitleId, id);
}
